import { linkLauncher } from './helpers';
import {
  createWebappRoute,
  getCurrentRouteParams,
  getRouter,
} from '../helpers';

export default [
  // "exec/*actions": "legacyApp",
  createWebappRoute({
    path: '/exec/:actions(.*)*',
    name: 'exec-module',
    component() {
      const actions = getCurrentRouteParams()?.actions[0] || '';

      if (!actions) {
        getRouter().push({ name: 'home-module' });
      }

      linkLauncher(`exec/${actions}`, false);
    },
  }),
];
